import axios from 'axios';
import _merge from 'lodash/merge';

import user from './../extra/user';

/**
 * @param {string} apiUrl - API endpoint
 * @param {object} payload - Data to be sent in the request body
 * @param {import('axios').AxiosRequestConfig & {
 *  isPublic: boolean,
 * }} options - Request options
 */
export default function put(apiUrl = '', payload = {}, options = {}) {
  if (!apiUrl) {
    throw new Error('API Endpoint was not provided');
  }

  const token = user.getToken();
  const endpoint = `${process.env.REACT_APP_BASE_URL}${apiUrl}`;

  const { isPublic = false, ...config } = options;

  const axiosConfig = _merge(
    { headers: isPublic ? {} : { Authorization: `Token ${token}` } },
    config
  );

  return axios.put(endpoint, payload, axiosConfig);
}
